import { render, staticRenderFns } from "./VentanaOperacionesEscanerActa.vue?vue&type=template&id=60b073ae"
import script from "./VentanaOperacionesEscanerActa.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesEscanerActa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports